/* 对账单模块 */
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/pointsMall/pointQr/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addApi(data) {
  return request({
    url: `/admin/pointsMall/pointQr/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/pointsMall/pointQr/update`,
    method: "POST",
    data,
  });
}


/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteApi(data) {
  return request({
    url: `/admin/pointsMall/pointQr/delete`,
    method: "POST",
    data,
  });
}

/**
 * 预览二维码（不保存到本地）
 * @param {string} code - 唯一编码
 * @returns {Promise<Blob>} 图片Blob对象
 */
export function previewApi(code) {
  return request({
    url: `/admin/pointsMall/pointQr/preview`,
    method: "POST",
    data: { code },
    responseType: "blob", // 接收二进制流
    // isEncrypt: false, // 不加密请求
    isDecrypt: false, // 不解密响应
  });
}

/**
 * 批量下载二维码图片（返回 ZIP 压缩包）
 * @param {Array<string>} codes - 唯一编码数组，最多 500 个
 * @returns {Promise<Blob>} ZIP文件Blob对象
 */
export function batchDownloadApi(codes) {
  return request({
    url: `/admin/pointsMall/pointQr/batchDownload`,
    method: "POST",
    data: { codes },
    responseType: "blob", // 接收二进制流
    isDecrypt: false, // 不解密响应
  });
}
